import { Button, Sheet, SheetContent, SheetHeader, SheetTitle } from '@miyuki/ui';
import { ArrowUpToLineIcon, CopyIcon, Trash2Icon } from 'lucide-react';

import { t } from '@/lib/i18n';

/**
 * Acciones de una fila, abiertas al tocar su número.
 *
 * Resuelve el caso real de descubrir que faltaba una fila veinte filas atrás:
 * insertar encima, duplicar o eliminar, con renumeración automática (RF-06).
 */
export interface RowActionsSheetProps {
  /** Índice de la fila; la fila mostrada es `row + 1`. */
  readonly row: number | null;
  readonly canRemove: boolean;
  readonly canGrow: boolean;
  readonly onInsertAbove: () => void;
  readonly onDuplicate: () => void;
  readonly onRemove: () => void;
  readonly onClose: () => void;
}

export function RowActionsSheet({
  row,
  canRemove,
  canGrow,
  onInsertAbove,
  onDuplicate,
  onRemove,
  onClose,
}: RowActionsSheetProps) {
  if (row === null) return null;

  return (
    <Sheet
      open
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <SheetContent side="bottom" className="pb-8">
        <SheetHeader>
          <SheetTitle>{t('rowActions', { n: row + 1 })}</SheetTitle>
        </SheetHeader>

        <div className="flex flex-col gap-2 px-4 pb-2">
          <Button variant="outline" size="touch" disabled={!canGrow} onClick={onInsertAbove}>
            <ArrowUpToLineIcon />
            {t('insertRowAbove')}
          </Button>
          <Button variant="outline" size="touch" disabled={!canGrow} onClick={onDuplicate}>
            <CopyIcon />
            {t('duplicateRow')}
          </Button>
          <Button
            variant="outline"
            size="touch"
            className="text-destructive"
            disabled={!canRemove}
            onClick={onRemove}
          >
            <Trash2Icon />
            {t('removeRow')}
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
